<template>
  <div v-if="!!value" class="px-0">
    <v-icon :small="small" v-if="value.error_status==='SUCCESS'" color="green">mdi-check-circle-outline
    </v-icon>
    <v-icon :small="small" v-if="value.error_status==='ERROR'" color="red" @click="onDetail(value)">mdi-alert-circle-outline
    </v-icon>
    <v-icon :small="small" v-if="value.error_status==='WARNING'" color="orange" @click="onDetail(value)">
      mdi-alert-circle-outline
    </v-icon>
    <v-dialog
        v-model="dialogItem"
        width="50%"
    >
      <v-card>
        <v-list dense>
          <v-list-item
              dense
              v-for="status_label of value.status_items" v-if="status_label.error_status_type !== 'SUCCESS'">
            <v-list-item-avatar v-if="status_label.error_status_type === 'ERROR'">
              <v-icon color="red">mdi-alert-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-icon color="orange">mdi-alert-circle-outline</v-icon>
            </v-list-item-avatar>
            {{status_label.label}}: {{status_label.text}}
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import BaseItem from "@/components/Base/BaseItem";

export default {
  name: 'BaseStatusIcon',
  inheritAttrs: false,
  props: {
    value: {default: null},
    small: {default: true},
    readonly: {default: false},
  },

  components: {
    BaseItem,
  },

  computed: {
    itemUid() {
      return this.childUid
    },
  },

  methods: {
    onDetail(item) {
      // console.log('onDetail', item)
      if (!this.readonly) {
        this.childUid = item.uid
        this.dialogItem = true
      }
    },
    onCancel() {
      this.dialogItem = false
      // this.itemUid = null
    },
    exception_traceback(editedItem) {
      if (!!editedItem && !!editedItem.exception_traceback)
        return editedItem.exception_traceback.replace('\n', '<br><br>')
    },
    error(editedItem) {
      if (!!editedItem && !!editedItem.error)
        return editedItem.error.replace('\n', '<br><br>')
    },

  },

  async mounted() {
  },

  data() {
    return {
      dialogItem: false,
      childUid: null,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
